var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union_5","data-name":"Union 5","d":"M-5857.637,7.779l-4.949,4.949L-5864,11.314l4.949-4.949L-5864,1.416-5862.586,0l4.949,4.949,4.951-4.95,1.414,1.414-4.95,4.95,4.95,4.95-1.414,1.416Z","transform":"translate(5864)","fill":"#333"}));
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 12.729 12.73"};

module.exports = Close;

Close.default = Close;
